export default __webpack_public_path__ + "static/media/03.f24bf659.jpg";